import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { NavigationExtras, Router } from '@angular/router';
import { AssignAdminDialogComponent } from 'src/app/modules/employment/assign-admin-dialog/assign-admin-dialog.component';
import { AssignJobAdminComponent } from 'src/app/modules/employment/assign-job-admin/assign-job-admin.component';
import { entityTypes, permissions, roles } from 'src/app/shared/helpers/roles-permissions';

@Component({
  selector: 'hour4u-admin-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.scss']
})
export class SuccessModalComponent implements OnInit {
  @Output() dataRefresh = new EventEmitter();
  roles = roles;
  entityTypes = entityTypes;
  permissions = permissions;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<SuccessModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) { }

  ngOnInit() {
    console.log(this.data)
  }

  // create Agency
  createAgency() {
    this.dialogRef.close(true);
    this.router.navigate(['/employer/all']);
  }

  // assign Agency
  assignAgency() {
    this.dialogRef.close(true);
    const dialogRef = this.dialog.open(AssignJobAdminComponent, {
      width: '600px',
      panelClass: 'assign-dialog',
      disableClose: true,
      data: this.data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataRefresh.emit();
      }
    });
  }

  // assign Enterprise
  assignEnterprise() {
    this.dialogRef.close(true);
    const dialogRef = this.dialog.open(AssignAdminDialogComponent, {
      width: '600px',
      panelClass: 'assign-dialog',
      disableClose: true,
      data: this.data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataRefresh.emit();
      }
    });
  }

  // create Enterprise
  createEnterprise() {
    this.dialogRef.close(true);
    this.router.navigate(['/enterprise-admin/enterprise-admins']);
  }

  // create Work Order
  createWorkorder() {
    this.dialogRef.close(true);
    const navigationExtras: NavigationExtras = {
      queryParams: { 'jobId': this.data.id, 'jobTypeId': this.data.jobTypeId, 'employerId': this.data.employerId }
    }
    this.router.navigate(['/enterprise-admin/create-work-order'], navigationExtras);
  }
}
